"use strict";
const { resolveExpression } = require('./evaluate');
const operatorIds = require('./definitions/operators');
const variableIds = require('./definitions/operandValueTypes');
const operandIds = require('./definitions/operandTypes');
const expressionGenerators = require('./definitions/factory/expressionFactory');
const constantGenerators = require('./definitions/factory/constantFactory');
const variableGenerators = require('./definitions/factory/variableFactory');
const defaultResolvers = require('./resolvers');
exports.resolveExpression = (expression, context = {}) => {
    const { resolvers = [] } = context;
    const combinedResolvers = [...defaultResolvers, ...resolvers];
    const expressionContext = Object.assign(Object.assign({}, context), { resolvers: combinedResolvers });
    return resolveExpression(expression, expressionContext);
};
exports.operatorIds = operatorIds;
exports.operandIds = operandIds;
exports.variableIds = variableIds;
exports.expressionGenerators = expressionGenerators;
exports.constantGenerators = constantGenerators;
exports.variableGenerators = variableGenerators;
//# sourceMappingURL=expressionHelper.js.map